import { Component, OnInit, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { finalize } from "rxjs";
import { VerifyCodeComponent } from "../verify-code/verify-code.component";
import { ICustomError } from "../../../Utils/_models/network-response";
import { AccountService } from "../../../Utils/_services/account/account.service";
import { LeftUiTemplateComponent } from "../left-ui-template/left-ui-template.component";


@Component({
  selector: "app-forgot",
  standalone: true,
  imports: [CommonModule, FormsModule, VerifyCodeComponent, LeftUiTemplateComponent],
  templateUrl: "./forgot.component.html",
  styleUrl: "./forgot.component.css",
})
export class ForgotComponent implements OnInit {
  constructor(
    private accountService: AccountService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  year = signal(new Date().getFullYear());
  public forgotModel = {
    usernameOrEmail: "",
  };
  public isLoading = signal(false);
  public errorMessage = signal("");
  emailSent = signal(false);

  ngOnInit(): void {}

  onSubmit(): void {
    if (this.isLoading()) return;

    if (!this.forgotModel.usernameOrEmail) {
      this.errorMessage.set("Please enter your username or email.");
      return;
    }

    this.isLoading.set(true);
    this.errorMessage.set("");

    this.accountService
      .forgot({ email: this.forgotModel.usernameOrEmail })
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: res => {
          if (res.data.emailSent) {
            this.emailSent.set(res.data.emailSent);
            this.toastr.info("Verification code sent to your email");
          }
        },
        error: (err: ICustomError) => {
          this.toastr.info(err?.error?.msg ?? err);
        },
      });
  }

  navigateToLogin(): void {
    this.router.navigate(["/auth/login"]);
  }

  clearError(): void {
    this.errorMessage.set("");
  }
}
